const MAX_QUERY_LENGTH = 200
const MAX_WORDS = 8
const MIN_WORD_LENGTH = 3

export function isSearchableQuery(value: string) {
	const query = value.trim()
	if (query.length < MIN_WORD_LENGTH || query.length > MAX_QUERY_LENGTH) {
		return false
	}
	const words = query.split(/\s+/).filter(Boolean)
	if (words.length > MAX_WORDS) {
		return false
	}
	return words.every((word) => word.length >= MIN_WORD_LENGTH)
}

export function sliceTitle(slice: string) {
	const clean = slice.replace(/^\.{3}/, '').trim()
	const line = clean.split('\n')[0] ?? ''
	if (line.length <= 60) {
		return line
	}
	return `${line.slice(0, 60)}…`
}

function escapeRegExp(value: string) {
	return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export function splitHighlight(text: string, query: string) {
	const words = query
		.trim()
		.split(/\s+/)
		.filter((word) => word.length >= MIN_WORD_LENGTH)
	if (words.length === 0) {
		return [{ text, match: false }]
	}
	const pattern = new RegExp(`(${words.map(escapeRegExp).join('|')})`, 'ig')
	return text
		.split(pattern)
		.filter((part) => part.length > 0)
		.map((part) => ({
			text: part,
			match: words.some((word) => word.toLocaleLowerCase() === part.toLocaleLowerCase()),
		}))
}
